export const BRANCH = process.env.REACT_APP_BRANCH;
export const CONTEXT = process.env.REACT_APP_CONTEXT;
export const COMMIT = process.env.REACT_APP_COMMIT;
export const BUILD_ID = process.env.REACT_APP_BUILD_ID;
export const BUILD_TIME = process.env.REACT_APP_BUILD_TIME;
export const NODE_ENV = process.env.NODE_ENV;